import { render, staticRenderFns } from "./ListaCalendarioMidiaSociais.vue?vue&type=template&id=7d844dda"
import script from "./ListaCalendarioMidiaSociais.vue?vue&type=script&lang=js"
export * from "./ListaCalendarioMidiaSociais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports